type ApiErrorNotificationListener = (message: string) => void;

const listeners = new Set<ApiErrorNotificationListener>();

export function notifyApiError(message: string): void {
  listeners.forEach((listener) => listener(message));
}

export function subscribeToApiErrors(listener: ApiErrorNotificationListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
